import React, { CSSProperties } from "react";
import ReactDOM from "react-dom/client";
// needed for row & cell level scope DnD setup
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// import "./index.css";

import {
  Cell,
  ColumnDef,
  Header,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { Link } from "react-router-dom";
// type Post = {
//   userId: number;
//   id: number;
//   title: string;
//   body: string;
//   url: Array<Url>;
// };
type Url = {
  name: string;
  url: string;
};

export const DragAlongCell = ({ cell }: { cell: Cell<any, unknown> }) => {
  const { isDragging, setNodeRef, transform } = useSortable({
    id: cell.column.id,
  });
  // console.log("cellSize", cell.column.getSize());

  function isString(value: unknown): value is string {
    return typeof value === "string";
  }
  // 日付形式の正規表現
  const dateRegex = /^\d{4}-\d{2}-\d{2}[A-Za-z]+$/;
  // セルの値を取得
  const cellValue = cell.getValue();
  // セルの値が文字列であり、日付形式に一致するかチェック
  const isDate = isString(cellValue) && dateRegex.test(cellValue);
  // セルの値が日付形式に一致するかチェック
  const productNoRegex = /^\d{8}-\d{2}$/;
  const isProductNo = productNoRegex.test(isString(cellValue) ? cellValue : "");

  // 数値かどうかを判断する関数
  function isNumber(value: unknown): value is number {
    return typeof value === "number";
  }
  // セルの値が数値かどうかを判断
  const isNum = isNumber(cellValue);

  const style: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: "relative",
    transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
    transition: "width transform 0.2s ease-in-out",
    width: cell.column.getSize(),
    maxWidth: cell.column.getSize(),
    minWidth: cell.column.getSize(),
    height: "27px",
    backgroundColor: isDate ? "#b3fea1" : "", // 日付の場合は背景を緑色に
    color: isDate ? "#00556f" : "", // 日付の場合は文字を白色に
    zIndex: isDragging ? 1 : 0,
    textAlign: isNum ? "right" : "left",
  };
  const styleLink: CSSProperties = {
    textDecoration: "underline",
    textDecorationColor: "#09A0F2",
    color: "#09A0F2",
  };
  return (
    // <td style={style} ref={setNodeRef}>
    //   {isProductNo ? (
    //     <Link to={`/drafts?productNo=${cellValue}`} style={styleLink}>
    //       {flexRender(cell.column.columnDef.cell, cell.getContext())}
    //     </Link>
    //   ) : (
    //     flexRender(cell.column.columnDef.cell, cell.getContext())
    //   )}
    // </td>
    <td style={style} ref={setNodeRef}>
      {isProductNo ? (
        <a
          href={`https://aqua-drafts.web.app?productNo=${cellValue}`}
          style={styleLink}
          target="_blank" // これで別タブで開くようにします
          rel="noopener noreferrer" // セキュリティ向上のために rel="noopener noreferrer" を追加
          onClick={(e) => e.stopPropagation()} // クリックイベントをキャンセル
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </a>
      ) : isNum ? (
        // If the value is a number, format it with toLocaleString for thousands separator
        cellValue.toLocaleString()
      ) : (
        // Otherwise, render the cell content as usual
        flexRender(cell.column.columnDef.cell, cell.getContext())
      )}
    </td>
  );
};
